import React from 'react';
import { Modal } from 'native-base';
import RichTextBox from './RichTextBox';
import { MODAL_WIDTH, EDIT_MODAL_MIN_HEIGHT } from '../../../Constants';
import { useDomParser } from '../../../hooks/useDomParser';
const EditBox = _ref => {
  var _topic$first, _topic$first$post;
  let {
    isTypeTopic: isFirstPost,
    topic,
    reply,
    showEditPostModal,
    setShowEditPostModal,
    handleTopicReply,
    onCloseHandler
  } = _ref;
  const {
    getParser,
    displayEditAtMentions
  } = useDomParser();
  const existingContent = isFirstPost ? {
    raw: topic === null || topic === void 0 ? void 0 : (_topic$first = topic.first) === null || _topic$first === void 0 ? void 0 : (_topic$first$post = _topic$first.post) === null || _topic$first$post === void 0 ? void 0 : _topic$first$post.cooked
  } : {
    raw: reply === null || reply === void 0 ? void 0 : reply.cooked
  };
  const parser = getParser();
  existingContent.raw = displayEditAtMentions(parser, existingContent.raw);
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: showEditPostModal,
    onClose: () => setShowEditPostModal(false),
    size: MODAL_WIDTH,
    w: "container",
    minH: EDIT_MODAL_MIN_HEIGHT,
    _overlay: {
      style: {
        position: 'fixed'
      }
    }
  }, /*#__PURE__*/React.createElement(Modal.Content, {
    minH: EDIT_MODAL_MIN_HEIGHT
  }, /*#__PURE__*/React.createElement(Modal.CloseButton, null), /*#__PURE__*/React.createElement(Modal.Header, null, "Edit"), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement(RichTextBox, {
    existingContent: existingContent,
    isFirstPost: isFirstPost,
    handleTopicReply: handleTopicReply,
    setShowModal: setShowEditPostModal,
    onCloseHandler: onCloseHandler,
    id: "edit",
    key: "edit"
  }))));
};
export default EditBox;
//# sourceMappingURL=EditBox.js.map